const KEY_PREFIX = "policyImport.cardMessages.";

const CARD_CATEGORY_MESSAGES = {
  ATUALIZA: `${KEY_PREFIX}ATUALIZA`,
  AMBIGUO: `${KEY_PREFIX}AMBIGUO`,
  CPF_DIFERENTE: `${KEY_PREFIX}CPF_DIFERENTE`,
  SEM_ITEM: `${KEY_PREFIX}SEM_ITEM`,
  SEM_CARD: `${KEY_PREFIX}SEM_CARD`,
  ERRO: `${KEY_PREFIX}ERRO`,
};

const CARD_WARNING_MESSAGES = {
  CPF_DIFERENTE: CARD_CATEGORY_MESSAGES.CPF_DIFERENTE,
  AMBIGUO: CARD_CATEGORY_MESSAGES.AMBIGUO,
  SEM_ITEM: CARD_CATEGORY_MESSAGES.SEM_ITEM,
  CARD_ANTIGO_SEM_ITEM: `${KEY_PREFIX}CARD_ANTIGO_SEM_ITEM`,
  RENOVACAO_INICIO_DISTANTE: `${KEY_PREFIX}RENOVACAO_INICIO_DISTANTE`,
  CPF_NOME_DIVERGENTE: `${KEY_PREFIX}CPF_NOME_DIVERGENTE`,
  CELULAR_CADASTRO_ATUALIZADO: `${KEY_PREFIX}CELULAR_CADASTRO_ATUALIZADO`,
};

/** Chaves i18n das mensagens (sem duplicatas, ordem: categoria e depois avisos). */
const buildCardMessages = (cardUpdate) => {
  if (!cardUpdate || typeof cardUpdate !== "object") return [];
  const messages = [];
  const push = (text) => {
    if (text && !messages.includes(text)) messages.push(text);
  };
  // "Motivo indisponível" (texto exato do servidor): a categoria não tem o que
  // dizer; os avisos continuam.
  if (typeof cardUpdate.categoria === "string" && cardUpdate.motivo !== "Motivo indisponível") {
    push(Object.prototype.hasOwnProperty.call(CARD_CATEGORY_MESSAGES, cardUpdate.categoria)
      ? CARD_CATEGORY_MESSAGES[cardUpdate.categoria]
      : null);
  }
  if (Array.isArray(cardUpdate.avisos)) {
    cardUpdate.avisos.forEach((aviso) => {
      if (typeof aviso === "string" && Object.prototype.hasOwnProperty.call(CARD_WARNING_MESSAGES, aviso)) {
        push(CARD_WARNING_MESSAGES[aviso]);
      }
    });
  }
  return messages;
};

/**
 * Classifica a resposta do POST /policy-document-imports/:id/efetivar.
 * Função pura; devolve só os campos abaixo (nada do restante da resposta).
 */
const classifyBase = (data) => {
  if (!data || typeof data !== "object") return { kind: "ok" };

  if (data.alreadyImported === true) {
    const id = data.existingPolicyId;
    return Number.isInteger(id) && id > 0
      ? { kind: "ja_importada", existingPolicyId: id }
      : { kind: "ja_importada" };
  }

  if (data.matchedManualPolicyId !== null && data.matchedManualPolicyId !== undefined) {
    return { kind: "atualizou_cadastro" };
  }

  return { kind: "ok" };
};

export const classifyEfetivarResult = (data) => {
  const base = classifyBase(data);
  // ja_importada: nada foi gravado; atualizou_cadastro: cadastro manual atualizado
  // (4B), o aviso do card não se aplica. Em ambos, cardUpdate não é lido.
  if (base.kind === "ja_importada" || base.kind === "atualizou_cadastro") return base;
  const cardMessages = buildCardMessages(data && data.cardUpdate);
  return cardMessages.length ? { ...base, cardMessages } : base;
};
